import { CheckCircle2, RotateCcw, FileText, User, Clock, Shield, Edit, Send, XCircle, LogIn, Activity } from "lucide-react";

const iconMap = {
  login: LogIn,
  logout: LogIn,
  quotation_created: FileText,
  quotation_updated: Edit,
  quotation_submitted: Send,
  quotation_cancelled: XCircle,
  quotation_reopened: RotateCcw,
  order_created: FileText,
  order_updated: Edit,
  order_submitted: Send,
  approval_approved: CheckCircle2,
  approval_revised: RotateCcw,
  user_created: User,
  user_updated: Edit,
  user_locked: Shield,
  user_unlocked: Shield,
  role_permissions_updated: Shield,
  customer_created: User,
  default: Activity,
};

const colorMap = {
  login: "text-blue-600 bg-blue-50 border-blue-200",
  logout: "text-gray-500 bg-gray-50 border-gray-200",
  quotation_created: "text-[#0052CC] bg-blue-50 border-blue-200",
  quotation_submitted: "text-yellow-700 bg-yellow-50 border-yellow-200",
  quotation_cancelled: "text-red-600 bg-red-50 border-red-200",
  approval_approved: "text-green-600 bg-green-50 border-green-200",
  approval_revised: "text-orange-600 bg-orange-50 border-orange-200",
  order_created: "text-[#0052CC] bg-blue-50 border-blue-200",
  order_submitted: "text-yellow-700 bg-yellow-50 border-yellow-200",
  default: "text-gray-600 bg-gray-50 border-gray-200",
};

export default function AuditTimeline({ events = [] }) {
  if (events.length === 0) {
    return <p className="text-sm text-gray-400 py-4 text-center">No activity recorded</p>;
  }

  return (
    <div data-testid="audit-timeline" className="relative">
      <div className="absolute left-5 top-0 bottom-0 w-px bg-gray-200" />
      <div className="space-y-4">
        {events.map((event, idx) => {
          const Icon = iconMap[event.action] || iconMap.default;
          const colors = colorMap[event.action] || colorMap.default;
          return (
            <div key={event.id || idx} className="relative flex items-start gap-3 pl-1">
              <div className={`relative z-10 w-9 h-9 rounded-full border flex items-center justify-center shrink-0 ${colors}`}>
                <Icon size={14} />
              </div>
              <div className="flex-1 min-w-0 pt-0.5">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-medium text-gray-800">
                    {event.action?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                  </span>
                  {event.user_name && (
                    <span className="text-xs text-gray-500">by {event.user_name}</span>
                  )}
                </div>
                {event.details && typeof event.details === "object" && (
                  <p className="text-xs text-gray-500 mt-0.5">
                    {Object.entries(event.details).map(([k, v]) => `${k}: ${v}`).join(" | ")}
                  </p>
                )}
                <div className="flex items-center gap-2 mt-1 text-[10px] text-gray-400">
                  <Clock size={10} />
                  {event.created_at ? new Date(event.created_at).toLocaleString() : "—"}
                  {event.ip_address && <span>| IP: {event.ip_address}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
